import { render, staticRenderFns } from "./procurement.vue?vue&type=template&id=1ca58ec8&scoped=true"
import script from "./procurement.vue?vue&type=script&lang=js"
export * from "./procurement.vue?vue&type=script&lang=js"
import style0 from "./procurement.vue?vue&type=style&index=0&id=1ca58ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca58ec8",
  null
  
)

export default component.exports